var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube-3",
    clipPath: "url(#clip0_23461_9537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4423 17.0429L6.33952 16.9704C5.01068 16.9453 3.67885 16.9955 2.37709 16.7346C0.39538 16.3442 0.254975 14.4315 0.108553 12.8272C-0.0940309 10.5715 -0.0158052 8.27516 0.366296 6.03877C0.581918 4.78333 1.43036 4.03529 2.74215 3.95314C7.17192 3.6574 11.6308 3.6922 16.0505 3.8304C16.5169 3.84296 16.9872 3.91255 17.4475 3.99083C19.7191 4.37452 19.7752 6.54229 19.9227 8.36697C20.0691 10.21 20.0079 12.0627 19.7271 13.8942C19.5015 15.4096 19.0712 16.6814 17.252 16.8042C14.9734 16.9646 12.747 17.0941 10.4624 17.0526C10.4624 17.0429 10.4484 17.0429 10.4423 17.0429ZM8.03039 13.2051C9.74734 12.2551 11.4322 11.3205 13.1391 10.3772C11.4192 9.42718 9.73731 8.49261 8.03039 7.54935V13.2051Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23461_9537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9996,
    height: 19.9996,
    fill: "white",
    transform: "translate(0 0.394073)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeW);
export default __webpack_public_path__ + "static/media/youtube-w.58ccc97aab3570e8d32dc5aaddcc20e6.svg";
export { ForwardRef as ReactComponent };